import {Box} from '@mui/material';
import {env} from '../../config/env';

export default function NavBarLogoImg() {
  return (
    <Box
      data-testid="navbar-logo-img"
      component="img"
      src="/logo.svg"
      alt={`${env.appName} Logo`}
      sx={{height: 32, width: 'auto', mr: 1}}
    />
  );
}
